// eslint-disable-next-line import/prefer-default-export
export const SIGNIFYD_SCRIPT_URL =
  'https://cdn-scripts.signifyd.com/shopify/script-tag.js';
